/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { ProductApiResponseItem } from '../../products/storage/types';
import { Paddock } from '../types/SeedOrderFormType';

export enum SeedErrorCode {
  HomeBranch = 'urn:errors:invalid-homebranch',
  InvalidAccount = 'urn:errors:invalid-account',
  InvalidOrder = 'urn:errors:invalid-order',
  PriceUpdateDenied = 'urn:errors:price-update-denied',
  InternalNotesDenied = 'urn:errors:internal-notes-update-denied',
  InvalidStore = 'urn:errors:invalid-store',
}

export type SeedOrder = SeedOrderApiResponseItem[];
export type SeedOrderApiResponse = SeedOrderApiResponseItem[];
export interface SeedOrderApiResponseItem extends ProductApiResponseItem {
  lineId?: string;
  itemId?: string;
  quantity?: number;
  id: string;
  accountNumber: string;
  version: string;
  mixes: MixApiResponseItem[];
  originalPriceExcGst?: number;
  editedPriceExcGst?: number;
  sowingRate?: number;
  treatment?: boolean;
  isMixingFee?: boolean;
}
export interface MixApiResponseItem {
  id: string;
  name: string;
  mixType: string;
  deliveryAddress?: DeliveryAddress | null;
  deliveryInstructions: string | null;
  displayOrder: number;
  externalNotes?: string | null;
  gstAmount: number;
  internalNotes?: string | null;
  paddocks: Paddock[];
  products: ProductApiResponseItem[];
  storeId: string;
  subtotalAmountExcGst: number;
}
export interface DeliveryAddress {
  recordId: string | null;
  name: string;
  streetAddress: string;
  city: string;
  postcode: string;
  fullAddress: string | null;
}
